/*
  This is the currentUser store. It tracks the currently logged in user's data. When a user logs in, this store will take the login and 
  password and find the matching record in the reg table and populate this store's state with that data. This store's state holds an 
  attribute for each field in the reg table, where the name of the reg table field and the name of the attribute match.  
*/
import userServices from "@/services/user/userServices"

const state = () => ({
  // The currentUser state has an attribute to match each field in the reg table.
  currentUser: null,
  authToken: ''
})

// getters
const getters = {
  getCurrentUsersPractice: (state, getters) => {
    return state.currentUser?.practice
  },
  getCurrentUsersLogin: (state, getters) => {
    return state.currentUser?.login
  },
  getCurrentUsersPassword: (state, getters) => {
    return state.currentUser?.password
  },
  getCurrentUsersFirstName: (state, getters) => {
    return state.currentUser?.first_name
  },
  getCurrentUsersFullName: (state, getters) => {
    return state.currentUser?.first_name + " " + state.currentUser.last_name
  },
  getCurrentUsersRole: (state, getters) => {
    return state.currentUser?.role
  },
  getAuthToken:(state, getters)=>{
    return state.authToken
  },
  isUserLoggedIn:(state, getters) =>{
    if (state.currentUser) {
      return true
    }
    return false
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  setUser(state, user) {
    state.currentUser = user
  },
  clearUser(state) {
    state.currentUser = null
  },
  setUserPractice(state, practice) {
    state.currentUser.practice = practice
  },
  setAuthToken(state,token){
    state.authToken = token
  },
  clearAuthToken(state){
    state.authToken = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
